"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Alert = _interopRequireDefault(require("../Alert"));
var _excluded = ["timeout", "position", "className", "onClose"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SLIDEOUT_TIMELEFT = 1;
var FloatAlertBasic = function FloatAlertBasic(_ref, ref) {
  var timeout = _ref.timeout,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position,
    className = _ref.className,
    onClose = _ref.onClose,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(timeout && timeout / 1000),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    timeLeft = _useState2[0],
    setTimeLeft = _useState2[1];
  var show = (0, _react.useMemo)(function () {
    return !timeout || timeLeft > 0;
  }, [timeout, timeLeft]);
  var classNameToApply = (0, _classnames["default"])('layer-top', "alert-".concat(position), 'slide-in', {
    'slide-out': timeout && timeLeft === SLIDEOUT_TIMELEFT
  }, className);
  (0, _react.useEffect)(function () {
    var timer = -1;
    if (timeout && timeLeft === 0) {
      onClose === null || onClose === void 0 || onClose();
    } else if (timeout && timeLeft > 0) {
      timer = window.setTimeout(function () {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    }
    return function () {
      window.clearTimeout(timer);
    };
  }, [timeout, timeLeft, onClose]);
  return show ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], (0, _extends2["default"])({
    ref: ref,
    className: classNameToApply,
    onClose: onClose
  }, rest)) : null;
};
var FloatAlert = /*#__PURE__*/_react["default"].forwardRef(FloatAlertBasic);
var _default = exports["default"] = FloatAlert;